// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"5eaf42fe","4945":"b9e3a84f","9100":"5d3de965"}[chunkId] + ".chunk.css";
};